import React, { useContext } from 'react';
import { Container, Grid, Card, CardContent, Typography, Button, Box, useMediaQuery } from '@mui/material';

import whatsapp from "../../../assets/icons/whatsapp-icon.png";
import telefone from "../../../assets/icons/telefoneicon.png";
import email from "../../../assets/icons/email-icon2.png";
import getEmail, { getWhatsApp } from '../../../functions/getEmail';
import UserContext from '../../../context';


type CallButtonProps = {
  phoneNumber: string; // Número de telefone no formato internacional
};

const AtendimentoSection: React.FC<{handeClickFaleConosco(): void}> = ({handeClickFaleConosco}) => {
  
  const ctx = useContext(UserContext);
  
  // Função para verificar se o dispositivo é móvel
  const isMobileDevice = (): boolean => {
    return /Mobi|Android/i.test(navigator.userAgent);
  };

  const handeClickTelefone = () => {
    if (isMobileDevice()) {
      // No celular, abrir o discador
      window.location.href = `tel:${getWhatsApp()}`;
    } else {
      // No desktop, exibir alerta ou alternativa
      alert(`Por favor, ligue para o número: ${getWhatsApp()}`);
    }
  }
  
  const handeClickEmail = () => {

    const subject = "Solicitação de Informações sobre Planos de Saúde";
    const body = `
    Olá,

    Estou interessado(a) em saber mais sobre os planos de saúde oferecidos pela sua empresa. Gostaria de entender quais opções vocês têm disponíveis, incluindo valores, cobertura e benefícios adicionais.

    Por favor, envie as informações e me informe como posso dar continuidade ao processo. Caso necessário, podemos agendar uma conversa.

    Agradeço desde já pela atenção e fico no aguardo do seu retorno.

    Atenciosamente,
    ${
      ctx?.user ?  ctx.user.nome + " " + ctx.user.sobrenome : "[Seu Nome]"
    }
    
    ${
      ctx?.user ?  ctx.user.phone : "[Seu Telefone ou Informações de Contato]"
    }
    
  `;
    
    // Cria o link de email formatado
    const mailtoLink = `mailto:${getEmail()}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.open(mailtoLink);
  }
  
  const handeClickWhatsApp = () => {
    
    const number = `55${getWhatsApp()}`;

    let url = `https://wa.me/${number}?text=Ol%C3%A1%21%20Seja%20bem-vindo%28a%29%20ao%20Innova%20Plano%20de%20Sa%C3%BAde%21%20Estamos%20aqui%20para%20ajud%C3%A1-lo%28a%29%20a%20encontrar%20o%20plano%20ideal.%20Envie%20sua%20d%C3%BAvida%20ou%20solicite%20um%20or%C3%A7amento%21`;
    window.open(url, "_blank");
  }

  const isMobile = useMediaQuery("(max-width:768px)");

  return (
    <Container maxWidth="lg" style={{ padding: '1em', textAlign: 'center' }}>
      {/* Título e Descrição */}
      <Typography variant={isMobile ? "h6" : "h5"} gutterBottom textAlign="left">Cuidado e suporte, sempre ao seu lado</Typography>
      <Typography variant="body1" color="textSecondary" textAlign="justify" paragraph>
        Estamos aqui para atender você de forma rápida, prática e eficiente. Nossa equipe está disponível para esclarecer dúvidas e auxiliar em todas as etapas do cuidado.
      </Typography>
  
      {/* Cards de Atendimento */}
      <Grid container spacing={4} justifyContent="center">
        {/* Card 1 - Telefone */}
        <Grid item xs={12} sm={4}>
          <Card style={{ height: '100%' }}>
            <CardContent>
              <img src={telefone} alt="" style={{ height: "45px", margin: "0 auto"}}/>
              <Typography variant="h6">Telefone</Typography>
              <Typography variant="body2" color="textSecondary">
                Ligue para nosso suporte e fale diretamente com nossos atendentes.
              </Typography>
              <Button variant="contained" color="secondary" style={{ marginTop: '1rem' }} onClick={handeClickTelefone}>
                Ligar agora
              </Button>
            </CardContent>
          </Card>
        </Grid>
  
        {/* Card 2 - E-mail */}
        <Grid item xs={12} sm={4}>
          <Card style={{ height: '100%' }}>
            <CardContent>
              <img src={email} alt="" style={{ height: "45px", margin: "0 auto"}}/>
              <Typography variant="h6">E-mail</Typography>
              <Typography variant="body2" color="textSecondary">
                Envie-nos um e-mail e responderemos o mais breve possível.
              </Typography>
              <Button variant="contained" color="secondary" style={{ marginTop: '1rem' }} onClick={handeClickEmail}>
                Enviar E-mail
              </Button>
            </CardContent>
          </Card>
        </Grid>
  
        {/* Card 3 - Chat */}
        <Grid item xs={12} sm={4}>
          <Card style={{ height: '100%' }}>
            <CardContent>
              <img src={whatsapp} alt="" style={{ height: "45px", margin: "0 auto"}}/>
              <Typography variant="h6">WhatsApp</Typography>
              <Typography variant="body2" color="textSecondary">
                Converse com nossa equipe pelo WhatsApp.
              </Typography>
              <Button variant="contained" color="secondary" style={{ marginTop: '1rem' }} onClick={handeClickWhatsApp}>  
                Iniciar Conversa
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
  
      {/* Botão de Ação Principal */}
      <Box mt={4}>
        <Button variant="outlined" color="secondary" size="large" onClick={handeClickFaleConosco}>
          Fale Conosco
        </Button>
      </Box>
    </Container>
  );
}

export default AtendimentoSection;
